"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullWidthImageOptionField = void 0;
const EditorFieldBase_1 = require("./EditorFieldBase");
class FullWidthImageOptionField extends EditorFieldBase_1.EditorFieldBase {
}
exports.FullWidthImageOptionField = FullWidthImageOptionField;
